import React, { useState } from "react";
import styles from "./aside_menu.module.css";
import MobMenu from "../mob_menu/mob_menu";

function AsideMenu({
  checkMenu
}) {

  return (
    <div className={`${styles.menu} ${checkMenu && styles.menuOpened}`}>
      <MobMenu />
    </div>
  );
}

export default AsideMenu;
